/**
 * Platform Configuration
 * Mobil uygulama ve web sistemi arasında ayrım yapar
 */

export type Platform = 'mobile' | 'web';
export type OS = 'android' | 'ios' | 'unknown';

interface PlatformConfig {
  currentPlatform: Platform;
  isMobile: boolean;
  isWeb: boolean;
  os: OS;
}

const detectPlatform = (): Platform => {
  const path = window.location.pathname;
  if (path.startsWith('/driver-mobile-')) return 'mobile';
  return 'web';
};

const detectOS = (): OS => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('android')) return 'android';
  if (/iphone|ipad|ipod/.test(userAgent)) return 'ios';
  return 'unknown';
};

let currentPlatform: Platform = detectPlatform();
let currentOS: OS = detectOS();

export const platformConfig: PlatformConfig = {
  get currentPlatform() { return currentPlatform; },
  get isMobile() { return currentPlatform === 'mobile'; },
  get isWeb() { return currentPlatform === 'web'; },
  get os() { return currentOS; },
};

export const setPlatform = (platform: Platform) => {
  currentPlatform = platform;
  console.log(`🔄 Platform değiştirildi: ${platform}`);
};

export const getPlatform = (): Platform => currentPlatform;
export const isMobilePlatform = (): boolean => currentPlatform === 'mobile';
export const isWebPlatform = (): boolean => currentPlatform === 'web';
export const getOS = (): OS => currentOS;

export const redirectToPlatform = (platform: Platform) => {
  window.location.href = platform === 'mobile' ? '/driver-mobile-auth' : '/login';
};

if (import.meta.env.DEV) {
  console.log('🎯 Platform Config:', {
    currentPlatform,
    os: currentOS,
    pathname: window.location.pathname,
  });
}